/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2026-05-07 17:03:38
 */
import './index.scss'
import React, { useEffect, useRef, useCallback } from 'react'

declare const __BUILD_ENV__: string
import { v4 as uuid } from 'uuid'
import { Drawer, message } from 'antd'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { setAgentCustomerDrawerVisible } from '../../actions/main'
import desktopLib from '../../utils/desktopLib'

interface AgentCustomerInfo {
  qs?: string
}

interface IframeMessageData {
  type: string
  href?: string
}

export default function AgentCustomer() {
  const dispatch = useAppDispatch()
  const buildEnv = __BUILD_ENV__

  // 检测 Chrome 版本
  const getChromeVersion = () => {
    const ua = navigator.userAgent
    const match = ua.match(/Chrome\/(\d+)/)
    return match ? parseInt(match[1], 10) : null
  }

  const chromeVersion = getChromeVersion()
  console.log('chromeVersion', chromeVersion)
  const isChromeVersionSupported =
    chromeVersion !== null && chromeVersion >= 111

  // 根据 Chrome 版本和构建环境确定 agentUrl
  // let agentUrl
  // if (isChromeVersionSupported) {
  //   // Chrome >= 111 使用新版本服务
  //   const assistantsUrlMap = {
  //     prod: 'https://assistants.xhey.top/web-customer-service?',
  //     staging: 'https://assistants-staging.xhey.top/web-customer-service?',
  //     test: 'https://assistants-test.xhey.top/web-customer-service?'
  //   }
  //   agentUrl = assistantsUrlMap[buildEnv] || assistantsUrlMap.test
  // } else {
  //   // Chrome < 111 使用旧版本服务
  //   const isProdOrStaging = ['prod', 'staging'].includes(buildEnv)
  //   agentUrl = isProdOrStaging
  //     ? 'https://h5.xhey.top/agentPlatform/agent?agent_id=99&type=pcCustomerService'
  //     : 'https://h5-test.xhey.top/agentPlatform/agent?agent_id=114&type=pcCustomerService'
  // }
  const agentUrl =
    'https://crm.jinrishuiyinxiangji.com/cs/widget?channel=web&source=web'
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const user = useAppSelector((store) => store.main.user)
  const agentCustomerDrawerStatus = useAppSelector(
    (store) => store.main.agentCustomerDrawerStatus
  )

  const visible = agentCustomerDrawerStatus?.visible || false
  const info: AgentCustomerInfo = agentCustomerDrawerStatus?.info || {}
  // 处理来自iframe的消息
  const handleIframeMessage = useCallback(
    (event: MessageEvent) => {
      try {
        const data: IframeMessageData =
          typeof event.data === 'string' ? JSON.parse(event.data) : event.data
        switch (data.type) {
          case 'navigateToCustomerService': {
            const contactUrl = `https://webchat-sh.clink.cn/chat.html?${info.qs}`
            if (desktopLib.isDesktop) {
              desktopLib.openContact(contactUrl)
            } else {
              window.open(
                contactUrl,
                '_blank',
                `width=500,height=600,left=${
                  (window.screen.availWidth - 500) / 2
                },top=${(window.screen.availHeight - 600) / 2})}`
              )
            }
            break
          }
          case 'openLink':
            window.open(
              data.href,
              '_blank',
              `width=500,height=600,left=${
                (window.screen.availWidth - 500) / 2
              },top=${(window.screen.availHeight - 600) / 2})}`
            )
            break
          default:
            return
        }
      } catch (error) {
        console.error('解析iframe消息失败:', error)
      }
    },
    [info]
  )

  // 添加消息监听器
  useEffect(() => {
    if (visible) {
      window.addEventListener('message', handleIframeMessage)
      return () => {
        window.removeEventListener('message', handleIframeMessage)
      }
    }
  }, [visible, handleIframeMessage])

  return (
    <Drawer
      title="客服会话"
      className="ai-chat-drawer"
      placement="right"
      size={isChromeVersionSupported ? 880 : 480}
      onClose={() => {
        dispatch(setAgentCustomerDrawerVisible(false, {}))
      }}
      open={visible}
    >
      <div className="mobile-screen">
        <iframe
          ref={iframeRef}
          src={`${agentUrl}&userId=${
            user ? user?.user_id : uuid()
          }&nickname=${user ? user?.nickname : ''}&mobile=${
            user ? user?.mobile : ''
          }&${info.qs ? `${info.qs}` : ''}`}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: '10px'
          }}
          allow="clipboard-write; clipboard-read; microphone; autoplay; encrypted-media"
        />
      </div>
    </Drawer>
  )
}
